import { render, staticRenderFns } from "./SpaceControllerView.vue?vue&type=template&id=659e9bd0&"
import script from "./SpaceControllerView.vue?vue&type=script&lang=js&"
export * from "./SpaceControllerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports